<template>
  <div class="main">
    <!-- <p class="bread">
      <span @click="$store.commit('changePath',{path:'video'})">视频库</span>
      <span style="margin-left:8px" v-if="!types_list.length && !uses_list.length">> 所有视频</span>
      <span style="margin-left:8px" v-if="types_list.length || uses_list.length">></span>
      <span
        @click="checkTab(item, 1, 0)"
        class="bread_ul"
        v-for="item in types_list"
        :key="item.id"
      >
        {{ item.name }}
        <img @click="checkTab(item, 1, 0)" :src="img.blue_close" alt="" />
      </span>
      <span
        @click="checkTab(item, 1, 1)"
        class="bread_ul"
        v-for="item in uses_list"
        :key="item.id"
      >
        {{ item.name }}
        <img @click="checkTab(item, 1, 1)" :src="img.blue_close" alt="" />
      </span>
    </p> -->
    <div class="content_wrap">
      <!-- 上面分类选择区 -->
      <div
        :style="{ pointerEvents: isloading ? 'none' : 'all' }"
        class="card_wrap"
      >
        <div class="card_top">
          <div class="classification clearfix">
            <span class="lab_text">{{ list[0].name }}</span
            ><i class="lab_colon">：</i>
            <ul class="clearfix">
              <li
                v-for="(child, ind) in list[0].list"
                :key="child.id"
                :class="type_ids.indexOf(child.id) != -1 ? 'curren_label' : ''"
                @click="checkTab(child, ind, 0)"
              >
                {{ child.name }}
              </li>
            </ul>
          </div>
          <div class="classification clearfix">
            <span class="lab_text">{{ list[1].name }}</span
            ><i class="lab_colon">：</i>
            <ul class="clearfix">
              <li
                v-for="(child, ind) in list[1].list"
                :key="child.id"
                :class="use_ids.indexOf(child.id) != -1 ? 'curren_label' : ''"
                @click="checkTab(child, ind, 1)"
              >
                {{ child.name }}
              </li>
            </ul>
          </div>
        </div>
        <div class="card_bottom">
          <div class="resolution_box">
            <div class="resolution">
              <span class="lab_text">分辨率</span><i class="lab_colon">：</i>
              <el-select
                @change="changeSort"
                :style="{ width: resolutionList1[resolution] }"
                v-model="resolution"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in resolutionList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="resolution">
              <span>比例：</span>
              <el-select
                :style="{ width: rateList1[rate] }"
                @change="changeSort"
                v-model="rate"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in rateList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="resolution">
              <span>时长：</span>
              <el-select
                @change="changeSort"
                :style="{ width: timeLong1[time] }"
                v-model="time"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in timeLong"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  {{ item.label }}
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="typeList">
            <div class="type_box">
              <span class="lab_text">类型</span>
              <i class="lab_colon">：</i>
              <ul>
                <li
                  v-for="(item, index) in typeList"
                  :key="index"
                  :class="typeIndex == index ? 'current_type' : ''"
                  @click="checkType(item, index)"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="sort_box">
          <div class="sort">
            <span class="sort_txt">排序：</span>
            <el-select
              @change="changeSort"
              v-model="sort"
              placeholder="请选择"
              :style="{ width: sort == '' ? '55px' : '85px' }"
            >
              <el-option
                v-for="item in sortList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div
            @click="enterInput(true, $event)"
            :class="showInput ? 'lang_search' : ''"
            class="video_search"
          >
            <el-input
              class="search_input"
              @change="changeKeyword"
              placeholder="搜视频"
              suffix-icon="el-icon-search"
              v-model="keyword"
            >
            </el-input>
          </div>
        </div>
      </div>
      <!-- 搜索结果标题 -->

      <div v-show="isShowResult" class="result">搜索结果：</div>
      <!-- 视频展示区 -->
      <div v-if="!isloading">
        <div class="video_none" v-if="!videoList.length">
          <img :src="img.none" alt="" />
        </div>
        <ul
          v-show="videoList.length"
          id="picture_wrap"
          ref="picture_wrap"
          class="picture_wrap"
        >
          <li
            class="picture_card"
            v-for="(item, index) in videoList"
            :key="index"
          >
            <div class="card_img" @mouseenter="getVideoIndex(index)">
              <router-link
                :to="{
                  name: 'videodetail',
                  query: { post_id: item.id, timeStmp: Date.parse(new Date()) },
                }"
              >
                <img
                  :title="item.title"
                  class="cover"
                  :src="item.cover"
                  alt=""
                />
                <img class="secret" :src="img.secret" alt="" />
                <i class="status_free" v-if="item.type == 1 && item.is_pay == 1"
                  >已购买</i
                >
                <i class="status_img" v-if="item.type == 1 && item.is_pay == 0"
                  >付费下载</i
                >
                <i class="status_free" v-if="item.type == 0">免费下载</i>
                <video
                  :id="'video_list' + index"
                  autoplay="autoplay"
                  muted
                  loop
                  :src="item.path"
                ></video>
              </router-link>
            </div>
            <div class="card_message">
              <span :title="item.title" class="card_title">{{
                item.title
              }}</span>
              <span class="card_time">{{
                com.timeFormat(item.video_info.play_time)
              }}</span>
            </div>
          </li>
        </ul>

        <!-- 页码区 -->
        <div v-show="total > 20" class="page">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout="pager"
            :page-size="20"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
      <loading v-if="isloading"></loading>
      <div class="advertisement" v-if="is_show">
        <el-carousel height="236px">
          <el-carousel-item v-for="item in ad_info" :key="item.id">
            <a :href="item.link" target="_blank">
              <img :src="item.img" alt="" />
            </a>
            <!-- <h3 class="small">{{ item }}</h3> -->
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import loading from "./../../widget/loading";
export default {
  components: {
    loading,
  },
  data() {
    return {
      isloading: true,
      showInput: false,
      list: [
        { name: "分 类", list: [] },
        { name: "用 途", list: [] },
      ],
      typeIndex: 0,
      resolution: "", //分辨率id
      rate: "", //视频比例id
      time: "", //视频时长id
      sort: "", //排序id
      type_id: "", //类型id
      typeList: [
        { name: "全部", id: "" },
        { name: "免费专区", id: 0 },
        { name: "精品专区", id: 1 },
      ],
      resolutionList1: {
        "": "46px",
        1: "77px",
        2: "85px",
        3: "103px",
        4: "61px",
        0: "46px",
      },
      resolutionList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "标清720P",
        },
        {
          value: "2",
          label: "高清1080P",
        },
        {
          value: "3",
          label: "4K高清2160P",
        },
        {
          value: "4",
          label: "8K极致",
        },
        {
          value: "0",
          label: "其他",
        },
      ],
      rateList1: {
        "": "46px",
        1: "46px",
        2: "38px",
        3: "56px",
        4: "41px",
        5: "41px",
        6: "38px",
        7: "38px",
        8: "38px",
        0: "46px",
      },
      rateList: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "16:9",
        },
        {
          value: "2",
          label: "4:3",
        },
        {
          value: "3",
          label: "2.39:1",
        },
        {
          value: "4",
          label: "2:1",
        },
        {
          value: "5",
          label: "3:2",
        },
        {
          value: "6",
          label: "1:1",
        },
        {
          value: "7",
          label: "1:2",
        },
        {
          value: "8",
          label: "2:3",
        },
        {
          value: "0",
          label: "其他",
        },
      ],
      timeLong1: {
        "": "46px",
        1: "74px",
        2: "86px",
        3: "94px",
        0: "46px",
      },
      timeLong: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "1",
          label: "30秒以下",
        },
        {
          value: "2",
          label: "31秒-1分钟",
        },
        {
          value: "3",
          label: "1分钟-2分钟",
        },
        {
          value: "0",
          label: "其他",
        },
      ],
      sortList: [
        {
          value: "",
          label: "默认",
        },
        {
          value: "down_num",
          label: "下载最多",
        },
        {
          value: "create_time",
          label: "最新上传",
        },
      ],
      keyword: "",
      videoList: [],
      // 当前页码
      currentPage: 1,
      type_ids: [], //选中的分类
      use_ids: [], //选中的用途
      types_list: [],
      uses_list: [],
      total: 0,
      is_show: false,
      ad_info: [],
      isShowResult: false, //是否显示搜索结果
    };
  },
  methods: {
    // 鼠标移入图片时，当前视频从0开始
    getVideoIndex(index) {
      $("#video_list" + index)[0].currentTime = 0;
    },
    // 点击搜索 收起
    enterInput(val, e) {
      e.stopPropagation();
      $(".search_input").find("input").focus();
      let _this = this;
      this.showInput = val;
    },
    // 获取广告列表
    getAdv() {
      let data = {
        cate: 1,
      };
      this.$store
        .dispatch("post", { url: "advList", data: data })
        .then((res) => {
          if (res) {
            this.is_show = res.data.is_show;
            this.ad_info = res.data.ad_info;
          }
        });
    },
    // 获取顶部分类、用途列表
    getTypeList() {
      let data = {
        cate_id: 1,
      };
      this.$store
        .dispatch("post", { url: "classification", data: data })
        .then((res) => {
          if (res) {
            this.type_ids = [res.data[0].list[0].id];
            this.use_ids = [res.data[1].list[0].id];
            this.list = res.data;
            if (this.com.getUrlParam("item")) {
              let item = JSON.parse(this.com.getUrlParam("item"));
              let ind = this.com.getUrlParam("ind");
              let index = this.com.getUrlParam("index");
              this.checkTab(item, ind, index);
              this.$store.commit('changePath',{path:'video'})
              this.getVideoList();

            }else{
              this.getVideoList();

            }
          }
        });
    },
    // 获取视频列表
    getVideoList() {
      this.isloading = true;
      let data = {
        cate: 1, //视频库
        type_ids: this.type_ids.join(","), //分类ids
        use_ids: this.use_ids.join(","), //用途ids
        keyword: this.keyword,
        type: this.type_id, //类型id
        order: this.sort, //排序方式
        page: this.currentPage,
        resolution: this.resolution,
        size: this.rate,
        time_long: this.time,
      };
      this.$store
        .dispatch("post", { url: "videoList", data: data })
        .then((res) => {
          this.isloading = false;
          if (res) {
            this.videoList = res.data.list;
            this.total = Number(res.data.count);
          }
        });
    },
    // 改变排序方式
    changeSort() {
      this.currentPage = 1;
      this.getVideoList();
    },
    // 写入keyword
    changeKeyword() {
      if (this.keyword == "") {
        this.isShowResult = false;
      } else {
        this.isShowResult = true;
      }
      this.currentPage = 1;
      this.getVideoList();
    },
    // 切换类型时，page置1，请求视频列表
    checkType(item, index) {
      this.type_id = item.id;
      this.currentPage = 1;
      this.typeIndex = index;
      this.getVideoList();
    },
    // 分页
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getVideoList();
    },
    // 分类、用途、格式切换
    checkTab(child, ind, index) {
      if (index == 0) {
        // 说明点的是分类的
        if (ind == 0) {
          // 说明点的是分类的全部
          this.type_ids = [child.id];
        } else {
          // 先把全部的去掉
          this.type_ids = this.type_ids.filter((it) => {
            return it != this.list[0].list[0].id;
          });
          // 然后判断是否已经有了，如果有了，去掉，没有的加上
          if (this.type_ids.indexOf(child.id) == -1) {
            this.type_ids.push(child.id);
            // 如果超过四个，去掉第一个
            if (this.type_ids.length >= 4) {
              this.type_ids.shift();
            }
          } else {
            this.type_ids = this.type_ids.filter((it) => {
              return it != child.id;
            });
          }
        }
        if (!this.type_ids.length) {
          this.type_ids = [this.list[0].list[0].id];
        }
      }

      if (index == 1) {
        // 说明点的是分类的
        if (ind == 0) {
          // 说明点的是用途的全部
          this.use_ids = [child.id];
        } else {
          // 先把全部的去掉
          this.use_ids = this.use_ids.filter((it) => {
            return it != this.list[1].list[0].id;
          });
          // 然后判断是否已经有了，如果有了，去掉，没有的加上
          if (this.use_ids.indexOf(child.id) == -1) {
            this.use_ids.push(child.id);
            // 如果超过四个，去掉第一个
            if (this.use_ids.length >= 4) {
              this.use_ids.shift();
            }
          } else {
            this.use_ids = this.use_ids.filter((it) => {
              return it != child.id;
            });
          }
        }
        if (!this.use_ids.length) {
          this.use_ids = [this.list[1].list[0].id];
        }
      }
      // 面包屑,展示选择的分类
      if (this.type_ids.indexOf(-1) == -1) {
        let fir_list = this.list[0].list;
        let arr = new Array();
        for (let i = 0; i < this.type_ids.length; i++) {
          for (let j = 0; j < fir_list.length; j++) {
            if (fir_list[j].id == this.type_ids[i]) {
              arr.push(fir_list[j]);
            }
          }
        }
        this.types_list = arr;
      } else {
        this.types_list = [];
      }
      // 面包屑选择显示的用途
      if (this.use_ids.indexOf(-2) == -1) {
        let second_list = this.list[1].list;
        let arr = new Array();
        for (let i = 0; i < this.use_ids.length; i++) {
          for (let j = 0; j < second_list.length; j++) {
            if (second_list[j].id == this.use_ids[i]) {
              arr.push(second_list[j]);
            }
          }
        }
        this.uses_list = arr;
      } else {
        this.uses_list = [];
      }

      this.currentPage = 1;
      this.getVideoList();
    },
  },
  created() {
    this.getTypeList();
    this.getAdv();
  },
  mounted() {
    let _this=this;
    $(".search_input")
      .find("input")
      .blur(function () {
        _this.showInput = false;
      });
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="less">
.resolution_box {
  margin-bottom: 18px;
  line-height: 14px;
}
.resolution {
  vertical-align: bottom;
  display: inline-block;
  margin-right: 32px;
  line-height: 14px;
  .el-input__suffix {
    right: 0;
  }
  span {
    color: #333;
    display: inline-block;
    line-height: 14px;

    i {
      width: auto;
    }
  }
}
.lab_text {
  display: inline-block;
}
.resolution .el-select {
  vertical-align: top;
}
.resolution .el-select .el-input {
  line-height: 14px;
  height: 14px;
}
.resolution .el-select .el-input__inner {
  border: none;
  height: 14px;
  font-size: 14px;
  color: #333333;
  padding: 0;
  line-height: 1;
  vertical-align: text-top;
}
.resolution .el-icon-arrow-up {
  line-height: 14px;
}
.resolution .el-icon-arrow-up:before {
  content: "\e78f";
  color: #202020;
}
.sort .el-select .el-icon-arrow-up:before {
  content: "\e78f";
  color: #202020;
}

.sort .el-input__inner {
  height: 26px;
  line-height: 26px;
  padding: 0;
  border: none;
  font-size: 14px;
  color: #333333;
}
.sort {
  span {
    display: inline-block;
  }
  .sort_txt {
    line-height: 26px;
  }
  .el-input__icon {
    line-height: 26px;
  }
}

// 右下角搜索框样式
.video_search .el-input__inner {
  border: none;
  background: #f3f4f7;
  color: #666666;
  height: 26px;
  line-height: 26px;
  padding: 0;
  padding-left: 12px;
}
.video_search .el-input__icon {
  line-height: 24px;
}
.video_search .el-input__suffix {
  width: 49px;
  background-color: #1f86f8;
  right: 0;
  border-radius: 4px 4px;
  color: #fff;
  height: 26px;
  line-height: 26px;
  font-size: 14px;
}
.lang_search .el-input__suffix {
  border-radius: 0 4px 4px 0px;
}
// .video_search:hover {
//   .el-input__suffix {
//     border-radius: 0 4px 4px 0px;
//   }
// }

// 页码栏样式
.page {
  .el-pagination .btn-next .el-icon,
  .el-pagination .btn-prev .el-icon {
    font-size: 18px;
  }

  .el-pager li {
    font-size: 18px;
    margin-right: 20px;
    border-radius: 5px;
    font-weight: 400;
  }

  .el-pagination button,
  .el-pagination span:not([class*="suffix"]) {
    font-size: 18px;
  }

  .el-pagination__editor.el-input .el-input__inner {
    font-size: 18px;
  }

  .el-icon-arrow-right:before {
    content: "下一页";
    font-weight: 400;
  }

  .el-pager li.active {
    background-color: #409eff;
    color: #fff;
  }
}
</style>

<style scoped lang="less">

.bread {
  height: 18px;
  line-height: 18px;
  cursor: pointer;
  width: 1300px;
  margin: 0 auto;
  margin-bottom: 10px;
  color: rgba(153, 153, 153, 1);
}
.bread_ul {
  margin-left: 8px;
  padding: 0 3px;
  border: 1px dashed #999999;
  position: relative;
}
.bread_ul img {
  position: absolute;
  right: -7px;
  top: 0px;
  width: 5px;
  height: 5px;
  opacity: 0;
}
.bread_ul:hover {
  border: 1px dashed rgba(23, 131, 255, 1);
  color: rgba(23, 131, 255, 1);
}
.bread_ul:hover img {
  transform: rotate(360deg);
  transition: 0.5s transform;
  opacity: 1;
}
.lab_colon {
  float: left;
  font-style: normal;
  font-size: 14px;
  line-height: 14px;
}
.lab_text {
  display: inline-block;
  width: 42px;
  font-size: 14px;
  color: #333;
  float: left;
  text-align-last: justify;
  line-height: 14px;
}
.advertisement {
  margin-top: 20px;
  img {
    width: 100%;
    height: 100%;
  }
}
.video_none {
  text-align: center;
  padding: 60px;
}

.curren_label,
.current_type {
  color: #1883ff !important;
}

.content_wrap {
  margin: 0 auto;
  width: 1300px;
  padding-bottom: 30px;
}

.card_wrap {
  position: relative;
  padding: 28px 32px 28px 32px;
  font-size: 14px;
  border-radius: 10px;
  background-color: #ffffff;
}

.card_top .classification {
  margin-bottom: 18px;
  li {
    cursor: pointer;
    float: left;
    margin-left: 32px;
    font-size: 14px;
    line-height: 14px;
    color: #333333;
    &:hover {
      color: #1883ff;
    }
    &:nth-child(1) {
      margin-left: 0;
    }
  }
}

.card_top .top_geshi {
  padding-bottom: 31px;
  padding-top: 13px;
  border-bottom: 1px solid #e1e1e1;

  li {
    float: left;
    margin-left: 30px;
    font-size: 14px;
  }
}

.card_bottom .typeList {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .type_box {
    width: 330px;
    li {
      float: left;
      margin-left: 32px;
      font-size: 14px;
      line-height: 14px;
      color: #333;
      &:hover {
        color: #1883ff;
      }
      &:nth-child(1) {
        margin-left: 0;
      }
    }
  }
}
.sort_box {
  position: absolute;
  right: 32px;
  bottom: 22px;
  display: flex;
  justify-content: space-between;
}
.sort_box .video_search {
  width: 49px;
  cursor: pointer;
  transition: all 0.5s;
}
.sort_box .lang_search {
  cursor: pointer;
  width: 186px;
  transition: all 0.5s;
}

// 搜索结果一行字
.result {
  margin-top: 15px;
  font-size: 14px;
  line-height: 14px;
}

// 图片展示区
.picture_wrap {
  display: flex;
  flex-wrap: wrap;
  min-height: 400px;
  .picture_card:nth-child(4n) {
    margin-right: 0px;
  }

  .picture_card {
    height: 201px;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    background-color: #ffffff;
    border-radius: 10px;
    position: relative;
    width: calc((100% - 75px) / 4);
    // width: 307px;
    margin-top: 20px;
    margin-bottom: 5px;
    margin-right: 25px;
    overflow: hidden;
    &:hover {
      box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.5);
    }
    .card_img {
      height: 171px;
      overflow: hidden;
      &:hover {
        .cover {
          display: none;
        }
        video {
          display: block;
          height: 100%;
        }
      }
      video {
        display: none;
        width: 100%;
      }
      .cover {
        width: 100%;
        height: 100%;
      }
    }

    .card_message {
      background: #ffffff;
      padding: 0 10px;
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      line-height: 30px;
      line-height: 30px;
      .card_time {
        padding: 0 10px;
        background: #fff;
        display: inline-block;
        z-index: 1;
        position: absolute;
        right: 0px;
      }
    }
  }
}

.page {
  margin-top: 24px;
  text-align: center;
}
</style>